// Dumb photo dialog — no store, no SQL, no API, no router. A card titled "Photo" with one photo, or
// a carousel with a "2 / 3" counter when there are several, and a Close button. Factored out of
// IssuesGrid at AM_ABSORPTION_PLAN step C5a (2026-10-16) — its markup, element for element — so
// IssuesGrid (issue-analysis) and AssetsGrid (asset-management) share it.
//
//   props:  modelValue    (Boolean)        v-model: the open state
//           photos        (Array<String>)  the image URLs, in display order (the parent decides
//                                          which photos and in what order); one → a single image,
//                                          several → the carousel + counter
//           divider       (Boolean)        the 400 px rule above the photos (IssuesGrid's look,
//                                          the default); AssetsGrid passes false (standalone
//                                          asset-management's dialog had none)
//           singleHeight  (String|Number)  the SINGLE photo's height (default '100%' — IssuesGrid's;
//                                          AssetsGrid passes 400, standalone AM's). The carousel
//                                          is always 400 high
//   emits:  update:modelValue  (Boolean)  the dialog's own close (scrim, Esc) and the Close button
//
// The carousel's position is the dialog's own state, back to the first photo whenever the
// dialog opens (IssuesGrid reset it in its opener). Its two strings are colocated in ./messages.
// The logic lives in ./setup.js.
import setup from './setup.js';

export default {
  name: 'item-photo-dialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    photos: {
      type: Array,
      default: () => []
    },
    divider: {
      type: Boolean,
      default: true
    },
    singleHeight: {
      type: [String, Number],
      default: '100%'
    }
  },
  emits: ['update:modelValue'],
  setup,
};
